module.exports = __webpack_public_path__ + "img/visa.0e286670.svg";